import React from 'react';
import { Link, usePage } from '@inertiajs/react';
import {
  root_path,
  terms_path,
  privacy_path,
} from '../../../lib/routes';
import { useFlash } from './useFlash';
export function PublicLayout({ children }) {
  const { props } = usePage();
  const appName = props.app_name ?? 'Speakflow';
  const businessName = props.app_config?.business_name;
  useFlash();
  return (
    <div className="min-h-screen flex flex-col bg-surface text-fg antialiased">
      {/* Header */}
      <header className="border-b border-edge-strong">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link
              href={root_path()}
              className="text-lg font-semibold text-fg tracking-tight"
            >
              {appName}
            </Link>
            <div className="flex items-center gap-4">
              <form action="/auth/speakflow" method="post">
                <input
                  type="hidden"
                  name="authenticity_token"
                  value={document.querySelector('meta[name="csrf-token"]')?.content ?? ''}
                />
                <button
                  type="submit"
                  className="text-sm font-medium text-fg-secondary hover:text-fg transition-colors"
                >
                  Sign in
                </button>
              </form>
            </div>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1">{children}</main>

      {/* Footer */}
      <footer className="border-t border-edge-strong">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-fg-tertiary">
              &copy; {new Date().getFullYear()} {businessName || appName}. All rights reserved.
            </p>
            <nav className="flex items-center gap-6">
              <Link
                href={terms_path()}
                className="text-sm text-fg-tertiary hover:text-fg transition-colors"
              >
                Terms of Service
              </Link>
              <Link
                href={privacy_path()}
                className="text-sm text-fg-tertiary hover:text-fg transition-colors"
              >
                Privacy Policy
              </Link>
            </nav>
          </div>
        </div>
      </footer>
    </div>
  );
}
